import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { TYPES } from "@/lib/api";

export const HeroSearch = ({ programmes }) => {
  const navigate = useNavigate();
  const [city, setCity] = useState("all");
  const [type, setType] = useState("all");
  const cities = [...new Set(programmes.map((p) => p.city))].sort();

  const go = () => {
    const qs = new URLSearchParams();
    if (city !== "all") qs.set("city", city);
    if (type !== "all") qs.set("type", type);
    navigate(`/programmes?${qs.toString()}`);
  };

  return (
    <div className="mt-14 max-w-3xl bg-white/10 backdrop-blur-xl border border-white/15 rounded-sm p-3 grid sm:grid-cols-[1fr_1fr_auto] gap-3 rise" style={{ animationDelay: "480ms" }} data-testid="hero-search">
      <Select value={city} onValueChange={setCity}>
        <SelectTrigger className="bg-white/95 border-0 h-12" data-testid="hero-search-city-select"><SelectValue placeholder="Ville" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Toutes les villes</SelectItem>
          {cities.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
        </SelectContent>
      </Select>
      <Select value={type} onValueChange={setType}>
        <SelectTrigger className="bg-white/95 border-0 h-12" data-testid="hero-search-type-select"><SelectValue placeholder="Type" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Tous les types</SelectItem>
          {Object.entries(TYPES).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}
        </SelectContent>
      </Select>
      <button onClick={go} className="h-12 px-6 bg-[#C88A58] hover:bg-[#b57849] text-white rounded-sm inline-flex items-center justify-center gap-2 text-sm transition-colors duration-300" data-testid="hero-search-button">
        <Search className="h-4 w-4" /> Rechercher
      </button>
    </div>
  );
};
